import React from 'react';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Clock } from 'lucide-react';
import { getAvailabilityColor, getAvailabilityText } from './utils';

function SlotCard({ slot, avail, price, isPast, onBook }) {
  const isFullyBooked = avail && avail.available_courts === 0;
  const isDisabled = isPast || isFullyBooked;

  return (
    <Card
      className={`time-slot-card p-3 sm:p-4 transition-all ${isDisabled ? 'opacity-50 bg-muted cursor-not-allowed' : 'cursor-pointer hover:shadow-lg'} ${!isDisabled && getAvailabilityColor(avail)}`}
      onClick={() => !isDisabled && onBook(slot)}
      data-testid={`time-slot-${slot}`}
    >
      <div className="flex justify-between items-center gap-2">
        <div className="min-w-0">
          <p className="font-bold" style={{ fontSize: 'max(15px, 1rem)' }}>{slot}</p>
          <p className="text-sm font-medium mt-0.5 truncate">
            {isPast ? 'Time has passed' : (isFullyBooked ? 'Fully booked' : getAvailabilityText(avail))}
          </p>
        </div>
        <div className="flex-shrink-0 text-right">
          {price && !isPast && (
            <p className="text-sm font-bold text-primary">
              BND {price.price_per_hour}/hr
            </p>
          )}
          {!isDisabled && (
            <Button
              size="sm"
              className="mt-1 w-full btn-primary"
              style={{ minHeight: '44px' }}
              onClick={(e) => { e.stopPropagation(); onBook(slot); }}
            >
              Book
            </Button>
          )}
        </div>
      </div>
      {isPast && <p className="text-xs text-muted-foreground mt-1">Not available</p>}
    </Card>
  );
}

export default function TimeSlotGrid({
  selectedLocation, isLocationClosed, timeSlots, loading,
  availability, pricing, isTimeSlotPast, onBook,
}) {
  return (
    <div>
      <div className="flex items-center justify-between mb-4 sm:mb-6">
        <h3 className="text-xl sm:text-2xl font-bold font-heading uppercase text-white">
          <Clock className="w-5 h-5 sm:w-6 sm:h-6 inline mr-2" /> Available Time Slots
        </h3>
        {loading && <span className="text-sm text-blue-200">Loading...</span>}
      </div>

      {isLocationClosed ? (
        <Card className="p-6 sm:p-8 text-center">
          <p className="text-xl font-bold text-red-600 mb-2">Location Closed</p>
          <p className="text-muted-foreground">
            {selectedLocation.name} is closed on this day. Please select a different date.
          </p>
        </Card>
      ) : timeSlots.length === 0 ? (
        <Card className="p-6 sm:p-8 text-center">
          <p className="text-muted-foreground">No time slots available for this date.</p>
        </Card>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
          {timeSlots.map((slot) => (
            <SlotCard
              key={slot}
              slot={slot}
              avail={availability[slot]}
              price={pricing[slot]}
              isPast={isTimeSlotPast(slot)}
              onBook={onBook}
            />
          ))}
        </div>
      )}
    </div>
  );
}

